import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SgKdConstants } from '../../../../sg-kd-shared/sg-kd-constants';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkd020dKouzaTypeService {

  private selectedKouzaTypeSubject = new BehaviorSubject<string | null>(null);

  selectedKouzaType$ = this.selectedKouzaTypeSubject.asObservable();

  constructor() { }

  setSelectedKouzaType(kouzaType: string): void {
    this.selectedKouzaTypeSubject.next(kouzaType);
  }

  getSelectedKouzaType(): string | null {
    return this.selectedKouzaTypeSubject.getValue();
  } 
}
